<template>
  <div class="customer-container">
    <!-- Nowoczesny nagłówek -->
    <div class="page-header">
      <h2 class="page-title">👤 Klienci</h2>
      <div class="header-actions">
        <router-link to="/addcontractor">
          <button class="btn-action btn-add">
            <span class="action-icon">➕</span>
            <span class="action-text">Dodaj</span>
          </button>
        </router-link>
        <router-link to="/contractors">
          <button class="btn-action">
            <span class="action-icon">📋</span>
            <span class="action-text">Lista</span>
          </button>
        </router-link>
        <router-link to="/company">
          <button class="btn-action">
            <span class="action-icon">🏢</span>
            <span class="action-text">Firma</span>
          </button>
        </router-link>
        <router-link to="/customer">
          <button class="btn-action">
            <span class="action-icon">👤</span>
            <span class="action-text">Klient</span>
          </button>
        </router-link>
      </div>
    </div>

    <!-- Sekcja wyszukiwania -->
    <div class="search-section">
      <div class="search-wrapper">
        <span class="search-icon">🔍</span>
        <input
          v-model="search"
          class="search-input"
          type="search"
          placeholder="Wyszukaj klienta po nazwie..."
        />
      </div>
    </div>

    <!-- Tabela klientów -->
    <div class="table-container">
      <table class="modern-table">
        <thead>
          <tr>
            <th>Typ</th>
            <th>Nazwa</th>
            <th>Numer telefonu</th>
            <th>Email</th>
            <th class="action-column">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contractor in filteredcontractors"
            :key="contractor.id"
            @click="openContractorModal(contractor)"
            class="table-row"
          >
            <td>
              <span class="icon">👤</span>
            </td>
            <td class="name-cell">{{ contractor.name }}</td>
            <td class="phone-cell">{{ contractor.phoneNumber }}</td>
            <td class="email-cell">{{ contractor.email }}</td>
            <td class="action-cell">
              <button
                class="btn-details"
                @click.stop="openContractorModal(contractor)"
              >
                Szczegóły
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <contractor-modal :contractor="contractor"></contractor-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ContractorModal from "../components/ContractorModal";

export default {
  data() {
    return {
      //   contractor: {
      //     brand: "",
      //     model: "",
      //     plate: "",
      //     vin: "",
      //     year: "",
      //     imageUrl: "",
      //   },
      //   openForm: false,
      search: "",
      contractor: "",
    };
  },
  components: {
    "contractor-modal": ContractorModal,
  },

  computed: {
    ...mapState(["userProfile", "contractors"]),
    customers() {
      return this.contractors.filter((item) => {
        return item.type === "customer";
      });
    },
    filteredcontractors() {
      return this.customers.filter((item) => {
        return item.name.toUpperCase().includes(this.search.toUpperCase());
      });
    },
  },
  methods: {
    openContractorModal(contractor) {
      this.$modal.show("contractor-modal");
      this.contractor = contractor;
    },
  },
};
</script>

<style scoped>
/* --- Kontener główny --- */
.customer-container {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* --- Nagłówek strony --- */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.header-actions a {
  text-decoration: none;
}

.btn-action {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  text-decoration: none;
}

.btn-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-add {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  box-shadow: 0 2px 8px rgba(17, 153, 142, 0.3);
}

.btn-add:hover {
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.4);
}

.action-icon {
  font-size: 18px;
}

.action-text {
  font-size: 14px;
}

/* --- Sekcja wyszukiwania --- */
.search-section {
  margin-bottom: 20px;
}

.search-wrapper {
  position: relative;
  max-width: 100%;
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #a0aec0;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 12px 20px 12px 45px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* --- Tabela --- */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.modern-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.modern-table thead {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.modern-table thead th {
  padding: 18px 20px;
  text-align: left;
  font-weight: 700;
  font-size: 12px;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  z-index: 10;
}

.modern-table thead th.action-column {
  text-align: center;
}

.modern-table tbody tr {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.modern-table tbody tr::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #e9ecef 50%, transparent 100%);
}

.modern-table tbody tr:hover {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  transform: scale(1.01);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 1;
}

.modern-table tbody tr:last-child::after {
  display: none;
}

.modern-table tbody td {
  padding: 20px;
  font-size: 14px;
  color: #2c3e50;
  vertical-align: middle;
}

/* --- Ikona kontrahenta --- */
.icon {
  font-size: 24px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.modern-table tbody tr:hover .icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scale(1.1);
}

/* --- Komórki tabeli --- */
.name-cell {
  font-weight: 600;
  color: #1a202c;
}

.phone-cell {
  color: #4a5568;
  font-family: 'Courier New', monospace;
}

.email-cell {
  color: #4a5568;
}

.action-cell {
  text-align: center;
}

/* --- Przycisk szczegółów --- */
.btn-details {
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-details:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-details:active {
  transform: translateY(0);
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .customer-container {
    padding: 12px;
  }

  .page-header {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 22px;
  }

  .header-actions {
    width: 100%;
  }

  .btn-action {
    flex: 1;
    justify-content: center;
  }

  .action-text {
    display: none;
  }

  .table-container {
    overflow-x: auto;
    border-radius: 8px;
  }

  .modern-table {
    min-width: 900px;
  }

  .modern-table thead th,
  .modern-table tbody td {
    padding: 12px;
    font-size: 13px;
  }
}
</style>